<template>
	<div class="pageId">
		<van-nav-bar class="nav-bar" :title="lotteryS.lottery.name">
			<template #left>
				<van-icon name="arrow-left" color="#fff" size="24" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="record">
			<div class="period">
				<van-image class="cover" :src="lotteryS.lottery.image"></van-image>
				<div class="text">{{lotteryS.recordNow.period}}</div>
			</div>
			<van-count-down :time="Number(lotteryS.recordNow.countdown) * 1000" @finish="LotteryInfo()" />
		</div>
		<div class="record">
			<!-- <div class="period tyS">
				【{{lotteryS.lottery.minutes}} {{$t('textS7')}}】
			</div> -->
			<div class="period tyS" @click="$router.push({path:'/GameRecord'})">
				<van-icon name="more-o" size="20" color="#ff253f" />
				<div style="padding-left: 6px;"> {{$t('other.vote_history')}} </div>
			</div>
		</div>

		<div class='chooseS'>
			<div v-for="(item,index) in lotteryList" :key='index' class="chooseB" :class="{chooseC:isSelected(item)}"
				@click="toggleSelect(item,index)">
				{{item.options}}
			</div>
		</div>


		<div class="bottom-bar">
			<div class="barS">
				<div class="leftL">
					<van-icon name="cart-o" size="30" @click="shopping=!shopping " />
				</div>
				<div class="midT">
					<div>
						{{ $t("reservation.available_balance") }}:
					</div>
					<div class="num">{{ userInfo.user_money }}</div>
				</div>
				<div class="btn" @click="jiesuan()">
					{{ $t("setting.ok") }}
				</div>
			</div>

			<div class="wrapper" :class="{ active: shopping }">
				<div class="item">
					<span class="label">{{ $t("textS3") }}：</span>
					<div class="bet-number">{{ selectedItems.length==0?$t('choose.select') : converted() }}
					</div>
					<van-icon name="arrow-down" size="20" @click="shopping=!shopping " />
				</div>
				<div class="item">
					<span class="label">{{ $t("textS2") }}</span>
					<div class="amount-wrapper">
						<van-field v-model="money" type="digit" :placeholder="$t('reservation.price_place')" />
					</div>
				</div>
				<div class="item">
					<span class="label">
						{{ $t("textS1") }}
						<span class="label" style="color: #ff253f;">
							{{selectedItems.length }}
						</span>
					</span>
					<span class="label" style="padding-left: 10px;">
						{{ $t("textS4") }}
						<span class="label" style="color: #ff253f;">
							{{ selectedItems.length*money }}
						</span>
					</span>
				</div>
			</div>
		</div>

		<van-popup v-model="jiesuanpage">
			<div class="confirm-order-modal">
				<div class="list">
					<div v-for="(v, key) in selectedItems" :key="key" class="lise-item">
						<div class="main">
							<p style="padding-right: 10px;">{{ v.options}} </p>
							<p>{{ money }}{{ $t("reservation.unit") }}</p>
						</div>
						<van-icon @click="clearChooes(v)" name="close" />
					</div>
				</div>
				<div class="sub-bar">
					<van-button class="item cancel-btn" type="default" @click="jiesuanpage=false">
						{{ $t("setting.cancel") }}
					</van-button>
					<van-button class="item sub-btn" type="default" @click="doSub">
						{{$t("reservation.submit")}}
					</van-button>
				</div>
			</div>
		</van-popup>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				jiesuanpage: false,
				shopping: false,
				userInfo: {},
				id: this.$route.query.id,
				imgBj: 'https://api.vnbuomgirl.com//lottery/20230801/81123865251bb39af99d08c0840f256c.jpg',
				lotteryList: [],
				selectedItems: [],
				money: "",
				lotteryS: {},
				isClick: false
			};
		},
		created() {
			if (!localStorage.getItem("token")) {
				this.$router.push({
					path: "/Login"
				});
			} else {
				this.LotteryInfo();

			}
		},
		computed: {},
		methods: {
			back() {
				return window.history.back();
			},
			converted() {
				const data = this.selectedItems.map(keyword => keyword.options)
				console.log(data, '55555')
				return data.join(',')
			},
			converteds() {
				const data = this.selectedItems.map(keyword => keyword.id)
				console.log(data, this.selectedItems, '55555')
				return data.join(',')
			},
			isSelected(item) {
				return this.selectedItems.some(selected => selected.id === item.id)
			},
			toggleSelect(item) {
				this.shopping = true
				if (this.isSelected(item)) {
					// 如果已选中，则移除
					this.selectedItems = this.selectedItems.filter(
						selected => selected.id !== item.id
					)
				} else {
					// 如果未选中，则添加
					this.selectedItems = [...this.selectedItems, item]
				}
			},
			//提交
			doSub() {
				if(this.isClick){
					return false
				}
				this.isClick = true
				this.$http({
					method: "post",
					url: "lotterySubmit",
					data: {
						lottery_id: this.id,
						options: this.converteds(),
						amount: this.money
					}
				}).then((res) => {
					this.isClick = false
					if (res.code === 1) {
						this.$toast(res.msg);
						this.jiesuanpage = false
						this.LotteryInfo()
					} else {
						this.$toast(res.msg);
					}
				});
			},
			//提交1
			jiesuan() {
				if (this.selectedItems.length === 0) {
					this.$toast(this.$t("reservation.choose_num"));
					return false;
				}
				if (this.money === "") {
					this.$toast(this.$t("reservation.price_place"));
					return false;
				}
				console.log(this.selectedItems)
				this.jiesuanpage = !this.jiesuanpage
			},
			//删除
			clearChooes(item) {
				this.selectedItems = this.selectedItems.filter(
					selected => selected.id !== item.id
				)
			},
			//投票详情
			LotteryInfo() {
				console.log(this.$route.query.id)
				this.$http({
					method: "get",
					url: "LotteryInfo",
					data: {
						lottery_id: this.id
					}
				}).then((res) => {
					if (res.code === 1) {
						console.log(res.data)
						this.lotteryS = res.data;
						this.lotteryList = res.data.options
						this.getUserInfo()
					} else {
						this.$toast(res.msg);
					}
				});
			},
			//投票详情
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 1) {
						this.userInfo = res.data;
						console.log(res.data, '123456');
					} else {
						this.$toast(res.msg);
					}
				})
			},
		},
	};
</script>

<style lang="less" scoped>
	.pageId {
		min-height: 100vh;
		background-color: #f2f2f5;

		.tyS {
			color: #ff253f;
			font-size: 32px;
			font-weight: 700;
		}

		.nav-bar {
			background: linear-gradient(90deg, #f905e5, #e6c3a1);
		}

		.chooseS {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 30px 20px;

			.chooseC {
				background-color: #ff253f !important;
				color: #fff !important;
			}

			.chooseB {
				width: 22%;
				padding: 40px 0;
				background: #fff;
				border-radius: 10px;
				color: #7d7c7c;
				font-size: 40px;
				text-align: center;

			}
		}

		.record {
			background: #fff;
			box-shadow: 0 4px 4px 0 #cacaca;
			padding: 20px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.period {
				display: flex;
				align-items: center;

				.cover {
					width: 150px;
					height: 150px;
					object-fit: cover;
				}

				.text {
					font-size: 38px;
					padding-left: 20px;
				}

			}

			.van-count-down {
				color: #ff253f;
				font-size: 40px;
			}
		}

		.bottom-bar {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 2;

			.barS {
				position: relative;
				left: 0;
				right: 0;
				bottom: 0;
				height: 140px;
				background-color: #fff;
				box-shadow: 0 0 20px 0 #cacaca;
				z-index: 2;
				display: flex;
				align-items: center;


				.btn {
					padding: 20px 30px;
					margin: 0 30px;
					color: #fff;

					background: linear-gradient(270deg, #e6c3a1, #f905e5);
					font-size: 28px;
					border-radius: 16px;
				}

				.leftL {
					display: flex;
					align-items: flex-end;
					justify-content: center;
					padding: 0 30px;
					border-right: 1px solid #dadada;
				}

				.midT {
					flex: 1;
					display: flex;
					align-items: flex-end;
					justify-content: center;
					font-size: 30px;
					color: #000;

					.num {
						margin: 0 5px;
						color: #ff253f;
					}
				}
			}

			.active {
				transform: translateY(-140px);
				display: block !important;
			}

			.wrapper {
				position: absolute;
				left: 0;
				right: 0;
				bottom: 0;
				padding: 20px 20px 10px 20px;
				background-color: #fff;
				z-index: 1;
				box-shadow: 0 0 10px 0 #cacaca;
				transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.55, 1.01);
				display: none;

				.item {
					display: flex;
					flex-direction: row;
					align-items: center;
					height: 65px;

					.label {
						font-size: 30px;
						line-height: 30px;
						color: #000;
					}

					.bet-number {
						flex: 1;
						margin: 0 16px;
						overflow: auto;
						white-space: nowrap;
						-webkit-overflow-scrolling: touch;
						color: #ed37ae;
						font-size: 30px;
						font-weight: 500;
						height: 40px;
						line-height: 40px;
					}

					.amount-wrapper {
						flex: 1;
						display: flex;
						flex-direction: row;
						align-items: center;
					}
				}
			}
		}

	}



	.up {
		transform: rotate(180deg);
		transition: all 0.5s;
	}

	::v-deep .van-icon-more-o {
		color: #ff253f;
		font-size: 50px;
	}

	.linear-gradient {
		width: 100%;
		height: 2px;
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-popup {
		position: absolute;
	}

	::v-deep .van-overlay {
		position: absolute;
		background-color: rgb(70 67 67 / 70%);
	}

	::v-deep .van-popup--top {
		top: -1px;
	}

	.font-weight {
		font-weight: 700 !important;
	}




	.van-cell {
		font-size: 30px;
		line-height: 50px;
	}

	::v-deep .van-field__control {
		color: #ff253f;
	}

	.confirm-order-modal {
		display: flex;
		flex-direction: column;
		margin: auto;
		padding: 20px 30px;
		width: 610px;
		height: 680px;
		max-height: 50%;
		border-radius: 10px;
	}

	.confirm-order-modal .head {
		position: relative;
		height: 80px;
	}

	.confirm-order-modal .head .text {
		padding: 0 20px;
		height: 30px;
		line-height: 10px;
		text-align: center;
		font-size: 35px;
		font-weight: 500;
		color: #7e5678;
	}


	.van-popup--center {
		border-radius: 30px;
	}

	.confirm-order-modal .list {
		flex: 1;
		padding: 0 10px;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.confirm-order-modal .list .lise-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 20px 0;
		justify-content: space-between;
		border-bottom: 1px solid #999;
	}

	.confirm-order-modal .list .lise-item .main {
		display: flex;
		align-items: flex-end;
	}




	.confirm-order-modal .list .lise-item {
		color: #ff253f;
	}

	.confirm-order-modal .sub-bar {
		display: flex;
		align-items: center;
		margin-top: 30px;
		justify-content: space-around;
	}

	.confirm-order-modal .sub-bar .item {
		min-width: 40%;
		height: 80px;
		text-align: center;
		box-sizing: border-box;
		border-radius: 50px;
		font-size: 30px;
		font-weight: 500;
	}

	.confirm-order-modal .sub-bar .item.cancel-btn {
		border: 2px solid #979799;
		color: #979799;
		background-color: #fff;
	}

	.confirm-order-modal .sub-bar .item.sub-btn {
		background: linear-gradient(270deg, #e6c3a1, #f905e5);
		color: #fff;
		border: 0;
	}

	.list {
		padding: 4vw;
	}

	.list .item {
		background-color: #e4e4e7;
		border-radius: 16px;
		padding: 40px;
		margin-bottom: 20px;
	}
</style>